<ng-container [formGroup]="form">
  <mat-form-field2 [showLabel]="showLabel">
    <input matInput type="number" i18n-placeholder placeholder="Days" formControlName="days" />
    <mat-hint align="end" i18n>default days is 0</mat-hint>
    <mat-error *ngIf="form.get('days').hasError('required')" i18n>Days is required</mat-error>
    <mat-error *ngIf="form.get('days').hasError('min')" i18n
      >Days need to be at least {{ form.get('days').getError('min').min }}</mat-error
    >
    <mat-error *ngIf="form.get('days').hasError('max')" i18n
      >Days need to be at most {{ form.get('days').getError('max').max }}</mat-error
    >
  </mat-form-field2>
  <mat-form-field2 [showLabel]="showLabel">
    <input matInput type="number" i18n-placeholder placeholder="Hours" formControlName="hours" />
    <mat-hint align="end" i18n>default hours is 0</mat-hint>
    <mat-error *ngIf="form.get('hours').hasError('required')" i18n>Hours is required</mat-error>
    <mat-error *ngIf="form.get('hours').hasError('min')" i18n
      >Hours need to be at least {{ form.get('hours').getError('min').min }}</mat-error
    >
    <mat-error *ngIf="form.get('hours').hasError('max')" i18n
      >Hours need to be at most {{ form.get('hours').getError('max').max }}</mat-error
    >
  </mat-form-field2>
</ng-container>
